import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import Cookies from "js-cookie";

import PrivacyPolicyModal from "./privacyPolicy/PrivacyPolicyModal";
import SaasModal from "./privacyPolicy/SaasModel";
import EulaModal from "./privacyPolicy/eulaModal";

import styles from "./Login.module.scss";

export default function Login() {
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [showSAASModal, setShowSAASModal] = useState(false);
  const [showEulaModal, setShowEulaModal] = useState(false);

  const [privacyContent, setPrivacyContent] = useState("");
  const [saasContent, setSaasContent] = useState("");
  const [eulaContent, setEulaContent] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const guestRef = params.get("guest_purchase_reference");
    if (guestRef) {
      localStorage.setItem("guest_purchase_reference", guestRef);
    }
  }, []);

  const login = useMutation({
    mutationFn: () =>
      axios.get(`/auth/get_dentally_request_auth_link?capture=default`),
    onSuccess: (res) => window.location.replace(res.data),
  });

  const loadDoc = async (id: number, setter: any, modalSetter: any) => {
    try {
      const res = await axios.get(`document_agreement/${id}`);
      setter(res.data.document);
    } catch {
      setter("Failed to load document.");
    } finally {
      modalSetter(true);
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.centerWrap}>
        <div className={styles.card}>
          {/* LEFT */}
          <div className={styles.left}>
            <div className={styles.brand}>
              <img src="/logo.png" className={styles.logo} alt="Medicube" />

              <div className={styles.tagline}>
                <div className={styles.orangeText}>
                  Make your consent clauses
                </div>
                <div className={styles.captionText}>
                  & match them to your frequently used treatment codes
                </div>
              </div>
            </div>

            <div className={styles.imageWrap}>
              <img src="doc2.png" className={styles.image} alt="Doctors" />
            </div>
          </div>

          {/* RIGHT */}
          <div className={styles.right}>
            <button className={styles.aboutBtn}>About</button>

            <div className={styles.content}>
              <h1>Welcome!</h1>

              <p className={styles.subText}>
                Smart consent management with a streamlined workflow
              </p>

              <Button
                className={styles.loginBtn}
                onClick={() => login.mutate()}
              >
                Login via <img src="/dentally-Photoroom.png" />
              </Button>

              <p className={styles.privacy}>
                By continuing, you agree to our{" "}
                <span
                  onClick={() =>
                    loadDoc(3, setPrivacyContent, setShowPrivacyModal)
                  }
                >
                  Privacy Policy
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* FOOTER */}
      <footer className={styles.footer}>
        <img src="/logo.png" />
        <p>© 2024 Medicube. All rights reserved.</p>
        <div className={styles.links}>
          <span onClick={() => loadDoc(3, setPrivacyContent, setShowPrivacyModal)}>
            Privacy Policy
          </span>
          |
          <span onClick={() => loadDoc(2, setSaasContent, setShowSAASModal)}>
            SAAS
          </span>
          |
          <span onClick={() => loadDoc(1, setEulaContent, setShowEulaModal)}>
            EULA
          </span>
        </div>
      </footer>

      <PrivacyPolicyModal
        open={showPrivacyModal}
        onClose={() => setShowPrivacyModal(false)}
        content={privacyContent}
      />
      <SaasModal
        open={showSAASModal}
        onClose={() => setShowSAASModal(false)}
        content={saasContent}
      />
      <EulaModal
        open={showEulaModal}
        onClose={() => setShowEulaModal(false)}
        content={eulaContent}
      />
    </div>
  );
}
